import React from "react";
import classNames from "classnames";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { MdOutlineWarningAmber } from "react-icons/md";

interface AlertProps {
  variant: "warning" | "info";
  content: string | React.ReactNode;
  className?: string;
}

const Alert = ({ variant, content, className }: AlertProps) => {
  const getColor = () => {
    switch (variant) {
      case "info":
        return "#31c48d";
      case "warning":
        return "#f98080";
    }
  };

  const getIcon = () => {
    switch (variant) {
      case "info":
        return IoMdInformationCircleOutline;
      case "warning":
        return MdOutlineWarningAmber;

      default: {
        console.warn("Unhandled variant", variant);
        return null;
      }
    }
  };

  const Icon = getIcon();

  return (
    <div
      className={classNames(
        "flex items-start px-2 py-4 rounded-lg border bg-[#F7F7F7]",
        {
          "border-green-400": variant === "info",
          "border-red-400": variant === "warning",
        },
        className
      )}
    >
      {Icon && <Icon className="w-6 h-6" color={getColor()} />}
      <div className="flex-1 px-2 whitespace-pre-line">{content}</div>
    </div>
  );
};

export default Alert;
